<section class="d-flex justify-content-between border-border align-items-center background-background header-padding">
  <ion-buttons slot="end" *ngIf="!showDesktopMenu">
    <ion-menu-button color="secondary"></ion-menu-button>
  </ion-buttons>

  <div
    #titleWrapper
    class="page-title-wrapper"
    [class.w-100]="!hideTitle"
    [class.centered]="!showDesktopMenu"
    [class.mr-4]="!showDesktopMenu"
  >
    <p
      *ngIf="!hideTitle"
      [style.max-width.px]="titleWrapper.offsetWidth"
      class="page-title"
    >{{ title }} <span class="badge-place badge badge-pill badge-info ml-2">{{ badgeCount }}</span></p>

    <div class="ml-3">
      <ng-content></ng-content>
    </div>
  </div>

  <div class="switcher-box" *ngIf="showDesktopMenu">
    <tablesready-theme-switcher [toggleId]="'desktop-switcher-' + routeId"></tablesready-theme-switcher>
    <tablesready-location-switcher *ngIf="hasBasicPermissions" class="ml-3" [id]="routeId"></tablesready-location-switcher>
  </div>
</section>

<div>
  <status-outlet></status-outlet>
</div>
